import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    createdRow: null,
    documents: [],
    selected: [],
    recordId: null,
    recordTitle: '',
    entityId: null,
    listId: null,
    relationId: null,
    pattern: '',
    totals: {},
    count: 0,
    collectionState: null,
    initError: false,
    feedback: null,
    views: [],
	isLoaded: false,
    currentViewId: 0,
    currentViewIndex: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT_COLLECTION:
            return {
                ...state,
                initError: false,
                isLoading: true,
                isLoaded: false
            }

        case types.INIT_COLLECTION_SUCCESS: {
            const views = action.views ? [...action.views] : state.views
            const viewId = action.data.viewId
            const currentViewIndex = views.findIndex(view => view.id === viewId)

            return {
                ...state,
                documents: [...action.data.records],
                record: {...action.data.record},
                collectionState: {...action.data.state},
                recordTitle: action.data.recordTitle,
                totals: action.data.totals,
                relationId: action.data.relationId,
                recordId: action.data.recordId,
                count: action.data.count,
                entityId: action.data.entityId,
                listId: action.data.listId,
                isLoading: action.data.isLoading,
                initError: false,
                pattern: action.data.textPattern,
                feedback: action.data.feedback,
                views,
                currentViewId: viewId,
                currentViewIndex,
                isLoaded: true
            }
        }

        case types.INIT_COLLECTION_FAILED:
            return {
                ...state,
                isLoading: false,
                initError: true
            }

        case types.VIEW_STATE_UPDATE_SUCCESS:
            return {
                ...state
            }

        case types.VIEW_STATE_UPDATE_FAILED:
            return {
                ...state
            }

        case types.DOCUMENT_ADD_SUCCESS:
            return {
                ...state,
                createdRow: action.data.id
            }

        case types.DOCUMENT_ADD_FAILED:
            return {
                ...state
            }

        case types.DOCUMENT_DELETE_SUCCESS:
            return {
                ...state,
                selected: []
            }

        case types.DOCUMENT_DELETE_FAILED:
            return {
                ...state
            }

        case types.DOCUMENT_SELECTION_CHANGE:
            return {
                ...state,
                selected: action.selected
            }

        case types.RESET_CREATED_ROW:
            return {
                ...state,
                createdRow: initialState.createdRow
            }

        case types.SET_TEXT_FILTER_SUCCESS:
            return {
                ...state
            }

        case types.SET_TEXT_FILTER_FAILED:
            return {
                ...state
            }

        case types.SET_FEEDBACK:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_FEEDBACK_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_FEEDBACK_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.CREATE_VIEW_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.CREATE_VIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                views: [...action.data]
            }

        case types.CREATE_VIEW_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SELECT_VIEW:
            return {
                ...state,
                currentViewId: action.viewId
            }

        case types.DELETE_VIEW_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.DELETE_VIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                views: [...action.data]
            }

        case types.DELETE_VIEW_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.UPDATE_VIEW_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.UPDATE_VIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                views: [...action.data]
            }

        case types.UPDATE_VIEW_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.REORDER_VIEWS_SUCCESS:
            return {
                ...state,
                views: [...action.data]
            }

        case types.REORDER_VIEWS_FAILED:
            return {
                ...state
            }

        case types.RESET_VIEWS:
            return {
                ...state,
                views: [],
                isLoaded: false,
                currentViewId: 0,
                currentViewIndex: 0
            }

        case types.VIEW_CLONE_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.VIEW_CLONE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                views: [...action.data]
            }

        case types.VIEW_CLONE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}
